<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>对账单</el-breadcrumb-item>
            <el-breadcrumb-item>订单汇总</el-breadcrumb-item>
        </el-breadcrumb>

        <el-row class="sunFinance" v-if="bill">
            <el-col :span="6">供应金额：<span>{{bill.order_total}}</span> 元</el-col>
            <el-col :span="6">运费金额：<span>{{bill.express_total}}</span> 元</el-col>
            <el-col :span="6">退款金额：<span>{{bill.refund_total}}</span> 元</el-col>
            <el-col :span="6"><el-button type="default" @click="createBill" v-auth="['store/finance/createOrderbill']">立即生成</el-button></el-col>
        </el-row>
        <el-row class="sunFinance" v-if="bill">
            <el-col :span="24">合计：<span>{{bill.order_count}}</span> 单 金额：<span>{{bill.result_totals}}</span> 元</el-col>
        </el-row>

        <table class="table" width="100%" cellpadding="0" cellspacing="0">
            <tr>
                <th>商品</th>
                <th>单价/数量</th>
                <th>总金额</th>
                <th>来源</th>
                <th width="120">买家</th>
                <th width="80">退款金额</th>
            </tr>
            <template v-for="(item, index) in list">
                <tr>
                    <th colspan="8">{{item.created_date}} 订单编号：{{item.order_sn}}</th>
                </tr>
                <tr v-for="(val , key) in item.order_goods">
                    <td>
                        <div class="thumb">
                            <img :src="val.pic_url">
                            {{val.product_name}}（{{val.sku_name}}）
                        </div>
                    </td>
                    <td>
                        {{(parseFloat(val.supplier_price) + parseFloat(val.platform_add_price)).toFixed(2)}}元/{{val.number}} 件
                    </td>
                    <td>
                        <el-tag size="small">{{(parseFloat(val.supplier_total_price) + parseFloat(val.platform_add_money)).toFixed(2)}}元</el-tag><br>
                    </td>
                    <template v-if="!key">
                    <td :rowspan="item.order_goods.length">
                        {{item.supplier_id ? (item.supplier ? item.supplier.name : '非自营') : '自营'}}
                    </td>
                    </template>
                    <template v-if="!key">
                    <td :rowspan="item.order_goods.length">
                        {{item.buyer ? item.buyer.nick_name : ''}}
                        {{item.buyer ? item.buyer.mobile : ''}}
                    </td>
                    </template>
                    <td>
                        <span v-if="val.refund">{{val.refund_money}}</span>
                        <span v-else>0</span>
                    </td>
                </tr>
            </template>
        </table>
    </div>
</template>
<script>
    export default {
        name: 'create_bill',
        data() {
            return {
                bill: null,
                list: [],
                isLoad: false
            }
        },
        created() {
            this.loadList()
        },
        methods: {
            loadList() {
                this.isLoad = true
                this.axios.get('store/finance/createOrderbill',{
                }).then(res => {
                    this.isLoad = false
                	this.list = res.data.list
                    this.bill = res.data.bill
                }).catch(() => {
                    this.isLoad = false
                }).finally(() => {
                    this.isLoad = false
                })
            },
            createBill: function () {
                var _this = this
                this.isLoad = true
                this.axios.post('store/finance/createOrderbill',{
                }).then(res => {
                    if (res.code == 1) {
                        this.isLoad = false
                        this.$message.success({
                            message: '生成成功'
                        });
                        setTimeout(function () {
                            _this.goBack()
                        }, 1500)
                    } else {
                        this.$message.success({
                            message: res.msg
                        });
                    }
                }).catch(() => {
                    this.isLoad = false
                }).finally(() => {
                    this.isLoad = false
                })
            },
            // 后退一步
            goBack() {
                this.$router.back(-1)
            },
        },

    }
</script>
<style scoped>
    .sunFinance {
        margin-bottom: 20px;
        text-align: center;
    }

    .sunFinance .el-col {
        height: 50px;
        line-height: 50px;
        font-size: 16px;

        border: 1px solid #EBEEF5;
        border-right: none;
    }

    .sunFinance .el-col:last-child {
        border-right: 1px solid #EBEEF5;
    }

    .sunFinance span {
        font-size: 20px;
        color: red;
    }

    .table {
        width: 100%;
        border-collapse: collapse;
    }

    .table td {
        border: 1px solid #EBEEF5;
        padding: 12px 10px;
        color: rgb(96, 98, 102);
        line-height: 23px;
    }

    .table th {
        line-height: 23px;
        border: 1px solid #EBEEF5;
        padding: 12px 10px;
        text-align: left;
        background: #f5f7fa;
        color: rgb(144, 147, 153);
    }
</style>
